import { render, staticRenderFns } from "./Co35Page.vue?vue&type=template&id=43305d39"
import script from "./Co35Page.vue?vue&type=script&lang=js"
export * from "./Co35Page.vue?vue&type=script&lang=js"
import style0 from "./Co35Page.vue?vue&type=style&index=0&id=43305d39&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports